export default "__VITE_ASSET__ffa43e7f__"